import { modifier } from 'ember-modifier';
import { scheduleOnce } from '@ember/runloop';

export default modifier((element) => {
  // eslint-disable-next-line ember/no-incorrect-calls-with-inline-anonymous-functions
  scheduleOnce('afterRender', this, () => element.focus());
}, { eager: false });
